import Container from './accept-lead-container';

export default Container;
